import { useMutation } from '@tanstack/react-query';
import { queryClient, QUERY_KEYS } from '@src/query';
import { ApiError } from '@src/services/api';
import { ApiTypes, CRMTemplateView } from 'common';
import { createCrmTemplate } from './api';
import { BodyCreateCRMTemplate } from 'common/dist/types/apiTypes';

export const useMutationCreateCRMTemplate = () =>
  useMutation<CRMTemplateView, ApiError, ApiTypes.BodyCreateCRMTemplate>({
    mutationFn: (template: BodyCreateCRMTemplate) => createCrmTemplate(template),
    onSuccess: async () => {
      const key = QUERY_KEYS.crmTemplates();
      queryClient.invalidateQueries({ queryKey: key });
    },
  });
